import React, {useMemo} from 'react';
import {IconProps} from './types';
import {useTheme} from '../../theme';
import {iconMap} from './iconMap';
import {colorNameMap, inverseColorNameMap, sizeMap} from './styles';

export const Icon: React.FC<IconProps> = ({
  name,
  size = '20',
  filled,
  inverse,
  transparent,
  kind = 'Primary',
  state = 'Default',
}) => {
  const theme = useTheme();
  const icon = iconMap[name];

  const color = useMemo((): string => {
    const colorName = inverse
      ? inverseColorNameMap[kind][state]
      : colorNameMap[kind][state];
    return theme.colors[colorName];
  }, [inverse, kind, state, theme.colors]);

  const baseSize = sizeMap[size];

  const IconComponent = filled ? (
    <icon.filled size={baseSize} color={transparent ? 'transparent' : color} />
  ) : (
    <icon.outline size={baseSize} color={transparent ? 'transparent' : color} />
  );
  return IconComponent;
};
